'use client';

import { cn } from '@/lib/utils/cn';
import { Logo } from '../../Logo';
import { WelcomeText } from '../../WelcomeText';
import { DeferredConsentAlert } from '../../Consent/DeferredConsentAlert';
import { TermsBlock } from '../../Consent/TermsBlock';
import { LoginTopSpacer } from '../../LoginTopSpacer';
import type { ILoginLayoutProps } from '../shared';

export const DefaultLoginLayout = ({
  fontFamily,
  hasConsent,
  isConsentRequired,
  shouldShowConsentAlert,
  isConsentAlertShaking,
  isConsentV2,
  sanitizedConsentHtml,
  onConsentChange,
  children,
}: ILoginLayoutProps): React.ReactElement => {
  return (
  <div
    className="login-template flex w-full flex-1 flex-col items-center px-4 pb-12"
    style={{ fontFamily }}
    data-testid="login-client-wrapper"
  >
    <div className="flex w-full flex-1 items-center justify-center">
      <div
        className={cn('transparent flex justify-center flex-col items-center w-full max-w-[500px]')}
      >
        {isConsentV2 ? (
          <LoginTopSpacer />
        ) : (
          <DeferredConsentAlert
            isVisible={shouldShowConsentAlert}
            isShaking={isConsentAlertShaking}
          />
        )}
        <Logo />
        <WelcomeText />
        {children}
        <TermsBlock
          hasConsent={hasConsent}
          onConsentChange={onConsentChange}
          isConsentRequired={isConsentRequired}
          sanitizedConsentHtml={sanitizedConsentHtml}
        />
      </div>
    </div>
  </div>
  );
};
